import { news } from "@/mocks/content";
import { GridCard } from "@/components/feature/Cards";

const PICK_IDS = [10, 16, 12, 7];

export default function TrendingGrid() {
  const byId = new Map(news.map((n) => [n.id, n]));
  const picks = PICK_IDS.map((id) => byId.get(id)!).filter(Boolean);
  return (
    <section className="border-t border-background-200 bg-background-100/40">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="mb-6 flex items-end justify-between">
          <div>
            <p className="mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-accent-600">
              <span className="inline-block h-3 w-1 rounded-full bg-accent-500" />
              Editor Picks
            </p>
            <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-900 md:text-3xl">
              今日最值得读完的四篇
            </h2>
          </div>
          <span className="hidden items-center gap-1.5 text-sm text-foreground-500 sm:inline-flex">
            <i className="ri-book-2-line text-accent-500" />
            由编辑部从全站挑选
          </span>
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {picks.map((item) => (
            <GridCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}